import {
	TextField,
	DialogTitle,
	DialogContent,
	Dialog,
	Button,
	DialogActions,
} from '@mui/material';
import { FC, useState } from 'react';
import { addShopRequest } from 'redux/reducers/shops/reducer';
import { useDispatch, useSelector } from 'react-redux';
import { getShopAddError } from 'redux/reducers/shops/selectors';

export const AddShop: FC<{
	open: boolean;
	onClose: () => void;
	setStep: (step: number) => void;
}> = ({ open, onClose, setStep }) => {
	const dispatch = useDispatch();

	const [shopName, setShopName] = useState('');
	const [shopNameError, setShopNameError] = useState<string | null>(null);
	const [url, setUrl] = useState('');
	const [urlError, setUrlError] = useState<string | null>(null);
	const [customerKey, setCustomerKey] = useState('');
	const [customerKeyError, setCustomerKeyError] = useState<string | null>(null);
	const [customerSecret, setCustomerSecret] = useState('');
	const [customerSecretError, setCustomerSecretError] = useState<string | null>(null);

	const validateForm = () => {
		setShopNameError(null);
		setUrlError(null);
		setCustomerKeyError(null);
		setCustomerSecretError(null);

		let validations = true;

		if (shopName.length < 2) {
			setShopNameError('Shop name is required');
			validations = false;
		}
		if (url.length < 3) {
			setUrlError('URL is required');
			validations = false;
		}
		if (customerKey.length < 3) {
			setCustomerKeyError('Customer key is required');
			validations = false;
		}
		if (customerSecret.length < 3) {
			setCustomerSecretError('Customer secret is required');
			validations = false;
		}

		return validations;
	};

	const handleShopNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setShopName(e.target.value);
		setShopNameError(null);
	};

	const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setUrl(e.target.value);
		setUrlError(null);
	};

	const handleCustomerKeyChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setCustomerKey(e.target.value);
		setCustomerKeyError(null);
	};

	const handleCustomerSecretChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		setCustomerSecret(e.target.value);
		setCustomerSecretError(null);
	};

	const eraseForm = () => {
		setShopName('');
		setUrl('');
		setCustomerKey('');
		setCustomerSecret('');
	};

	const handleAddShop = () => {
		if (!validateForm()) return;
		dispatch(
			addShopRequest({
				authCustomerKey: customerKey,
				authCustomerSecret: customerSecret,
				name: shopName,
				url,
			}),
		);
		eraseForm();
		setStep(2);
	};

	const handleCancel = () => {
		eraseForm();
		onClose();
	};

	return (
		<>
			<DialogTitle sx={{ fontWeight: 'bold', color: 'primary.main' }}>Add Shop</DialogTitle>
			<DialogContent sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
				<TextField
					label="Shop Name"
					value={shopName}
					onChange={handleShopNameChange}
					fullWidth
					required
					error={!!shopNameError}
					helperText={shopNameError}
					sx={{
						mt: 1,
					}}
				/>
				<TextField
					label="URL"
					value={url}
					onChange={handleUrlChange}
					fullWidth
					required
					error={!!urlError}
					helperText={urlError}
				/>
				<TextField
					label="Customer Key"
					value={customerKey}
					onChange={handleCustomerKeyChange}
					fullWidth
					required
					error={!!customerKeyError}
					helperText={customerKeyError}
				/>
				<TextField
					label="Customer Secret"
					value={customerSecret}
					onChange={handleCustomerSecretChange}
					fullWidth
					required
					error={!!customerSecretError}
					helperText={customerSecretError}
				/>
			</DialogContent>
			<DialogActions>
				<Button size="small" variant="outlined" color="primary" onClick={handleCancel}>
					Cancel
				</Button>
				<Button size="small" variant="contained" color="primary" onClick={handleAddShop}>
					Add Shop
				</Button>
			</DialogActions>
		</>
	);
};
